import { render } from "./LocaleImportButtons.vue?vue&type=template&id=db28053e"
import script from "./LocaleImportButtons.vue?vue&type=script&lang=js"
export * from "./LocaleImportButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__